/**
 * @generated SignedSource<<66476511f30c25648bae84a42047b2bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NameFields_User$data = {
  readonly firstName: string | null | undefined;
  readonly lastName: string | null | undefined;
  readonly " $fragmentType": "NameFields_User";
};
export type NameFields_User$key = {
  readonly " $data"?: NameFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"NameFields_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NameFields_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d1ab901bf54dbb1a5b2a7f42c06df960";

export default node;
